<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5irKrQ/images/cover.jpg?1684515198840" alt="This image is the cover for the book Beneath the Palisade: Reliance, Beneath the Palisade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beneath the Palisade: Reliance, Beneath the Palisade
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Beneath the Palisade Book</i></b></p><p>Rising star attorney Harper Callahan hires Ian Burke to landscape his backyard, but it’s his heart that gets the real makeover. Cautious at first, Ian is soon won over by Harper’s good looks and charm, and before they know it they’re on the fast track to romance.</p> <p>Then a brush with death makes Harper and Ian reassess their plans for the future… and offers them an opportunity for adventure. What starts out as a casual fantasy of owning and operating a B&amp;B on Lake Superior soon explodes into reality as Harper and Ian realize that when they rely on each other, they can accomplish great things.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joel Skelton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d6682e82